export default __webpack_public_path__ + "static/gmail-abe276f5ef2711d9ea13dd96fce6d5c2.pdf";